import React from 'react';
import {
    SmartHeader,
    SmartNoteImg,
    SmartHeaderInfo,
    SmartHeaderTitle,
    SmartWrapper,
    TvTable,
    TvTableRow,
    TvTableRowDesc,
    TvTableRowTitle,
    LinksContainer,
    NoteLink,
    EquipLink
} from './pageStyle';
import Link from 'next/link';
import { dataLayerPush } from '@ertelecom/ui-react/components/helpers';
import { EVENTS } from '~/src/constants/analytics';

export const Note = (props) => {

    // Костыль для сквозной авторизации в movix
    const getMovixHref = () => {
        let href = 'https://movix.ru';
        href = href + '?access_token=' + props.token + '&region=' + props.city;
        return href;
    };

    const smartText = [
        {
            title: 'Как смотреть ТВ на смартфоне или планшете?',
            desc: 'Установите бесплатное приложение «Дом.ru Movix».'
        },
        {
            title: 'Как смотреть ТВ на ноутбуке или обычном компьютере?',
            desc: <span>Зайдите на сайт <EquipLink rel='nofollow noopener noreferrer' href={getMovixHref()}>movix.ru</EquipLink>.</span>
        },
        {
            title: 'Я Клиент. Сколько телеканалов я могу смотреть в приложении и на сайте?',
            desc: <ol>
                <li>1. Если у вас подключено ТВ от Дом.ru, то доступны все телеканалы, которые есть в вашем тарифе.</li>
                <li> 2. Если у вас нет ТВ от Дом.ru, то вы можете смотреть 100 каналов бесплатно. Чтобы смотреть больше,
                    подключите <Link href='/domru-tv/channel'><EquipLink>тематические каналы</EquipLink></Link>.
                </li>
            </ol>
        },
        {
            title: 'Я не Клиент Дом.ru. Могу ли я пользоваться приложением?',
            desc: 'Да. Вы можете познакомиться приложением и посмотреть канал «Дом.ru Гид».'
        }
    ];

    const noteLinks = [
        {
            id: 1,
            title: 'Скачать в App Store',
            href: 'https://apps.apple.com/ru/app/dom-ru-tv/id825552263?ign-mpt=uo%3D4',
            gaEvent: 'btn click on app store'
        },
        {
            id: 2,
            title: 'Скачать в Google Play',
            href: 'https://play.google.com/store/apps/details?id=com.ertelecom.domrutv&referrer=utm_source%3DWebsite%26utm_medium%3DMovixru%26utm_term%3DMovixru',
            gaEvent: 'btn click on google play'
        },
        // Сквозная авторизация закостылена в getHref()
        {
            id: 3,
            title: 'Посетить кинотеатр Movix',
            href: getMovixHref(),
            gaEvent: 'btn click on movix'
        }
    ];

    const click = (id) => {
        const link = noteLinks.filter(item => item.id === id)[0];
        dataLayerPush({
            event: EVENTS.UAevent,
            category: 'equipment domru-tv',
            action: link.gaEvent,
            label: ''
        });
    };


    return (
        <SmartWrapper>
            <SmartHeader>
                <SmartHeaderInfo>
                    <SmartHeaderTitle>
                        Берите ТВ на прогулку или в дорогу. Смотрите каналы на экране смартфона, ноутбука, планшета.
                    </SmartHeaderTitle>
                    <LinksContainer>
                        {noteLinks.map(link =>
                            <NoteLink rel='nofollow noopener noreferrer' target='_blank' key={link.id} href={link.href} onClick={() => click(link.id)}>
                                {link.title}
                            </NoteLink>)}
                    </LinksContainer>
                </SmartHeaderInfo>
                <SmartNoteImg/>
            </SmartHeader>
            <TvTable>
                {
                    smartText.map((item, key) =>
                        <TvTableRow key={key}>
                            <TvTableRowTitle>{item.title}</TvTableRowTitle>
                            <TvTableRowDesc>{item.desc}</TvTableRowDesc>
                    </TvTableRow>)
                }


            </TvTable>
        </SmartWrapper>
    );
};
